import { Component } from "@angular/core";
import { NgForm } from "@angular/forms";
import * as _ from "lodash-es";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SubSink } from "subsink";
import { IEntity } from "../shared/models/entity";
import { Position } from "../shared/models/position";
import { IRosterType } from "../shared/models/roster/roster-type";
import { IWorkGroupPositionRosterType } from "../shared/models/roster/workgroup-position-rostertype";

@Component({
  selector: "pps-workgroup-position-rostertype-form",
  templateUrl: "./workgroup-position-rostertype-form.component.html"
})
export class WorkGroupPositionRosterTypeFormComponent{
  private subs = new SubSink();

  errorMessage = "";

  workGroups: IEntity[] = [];
  positions: Position[] = [];
  rosterTypes: IRosterType[] = [];

  selectedWorkGroups: IEntity[] = [];
  selectedPositions: Position[] = [];
  selectedRosterType: IRosterType = {id: 0};

  // item: IWorkGroupPositionRosterType = {
  //   workGroup: {id : 0},
  //   position: {id : 0},
  //   rosterType: {id : 0}
  // };

  constructor( 
    private _dialogRef: DynamicDialogRef,
    private _dlgConfig: DynamicDialogConfig) {
    this.setData(this._dlgConfig.data);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  setData(data: any){
    this.workGroups = _.cloneDeep(data.workGroups);
    this.positions = _.cloneDeep(data.positions);
    this.rosterTypes = _.cloneDeep(data.rosterTypes);
  }

  save(form: NgForm){
    this.errorMessage = "";

    if (form.invalid){
      return false;
    }

    if (this.selectedWorkGroups.length === 0){
      this.errorMessage = "Please select at least one work group";
      return;
    }

    if (this.selectedPositions.length === 0){
      this.errorMessage = "Please select at least one position";
      return;
    }

    if (this.selectedRosterType.id === 0){
      this.errorMessage = "Please select a roster type";
      return;
    }

    var items: IWorkGroupPositionRosterType[] = [];
    this.selectedWorkGroups.forEach(wg=>{
      this.selectedPositions.forEach(p => {
        items.push({
          workGroup: {id: wg.id},
          position: {id: p.id},
          rosterType: {id: this.selectedRosterType.id}
        });
      });
    });

    console.log(items);

    this._dialogRef.close(items);
  }

  cancel(){
    this._dialogRef.close();
  }  
}